module.exports = __webpack_public_path__ + "img/Arabic-10.ec5b8fbe.jpg";